import { ContactForm } from '../../contact-form';

if (document.body.id === 'account-need-help') {
    const $form = document.querySelector('#contact-form') as HTMLFormElement;
    const $formTemplate = document.querySelector('#contact-form-template') as HTMLTemplateElement;
    ContactForm($form, $formTemplate);
}
